import type { FaireProductEntity } from "../../entity_types/product";

export const p_6we8wppsb6: FaireProductEntity = {
  token: "p_6we8wppsb6",
  type: "product",
  name: "Tomato Green Gingham Task Pad Notebook Journal",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f16ccc927287b90f82eef191f67ec872630ab270cd63eaeac8bc9ff242d329b6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a860546c13ce6cc62ed13d0e5ce8ab8a9aba6855986c0bdbd85e0082ea5e844.webp",
    "https://cdn.faire.com/fastly/6fb8f1a1bed086242a7303d6d6d276f5fcbcd9ecdeb7194aa0189a690ed61edb.webp",
    "https://cdn.faire.com/fastly/d37804ba5eaeacb40459594c389589179a1e5c4d8d785abd3dd96970953ba117.webp",
  ],
  priceDollars: 11,
  description:
    "E. Frances Paper + Shorthand Press Task Pad\n\nThe Task Pad by Shorthand Press, the essential list notepad. With a letterpressed cover and beautiful interior pages, this lined rule notebook has checkboxes on each line allowing you to keep your lists all together.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:51.618Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
